import sliders      from './swiper/sliders.js';
import steps        from './swiper/steps.js';
import publications from './swiper/publications.js';
import gallery      from './swiper/gallery.js';
import reviews      from './swiper/reviews.js';

// Init
function init() {
	const heroWidget = [...document.querySelectorAll('[data-slider="hero"]')];
	heroWidget.forEach((item) => sliders(item, {
		loop          : true,
		slidesPerView : 1,
		effect        : 'fade',
		grabCursor    : true,
		fadeEffect    : {
			crossFade : true,
		},
		autoplay : {
			delay : 5000,
		},
	}));
	
	const defaultWidget = [...document.querySelectorAll('[data-slider="default"]')];
	defaultWidget.forEach((item) => sliders(item));
	
	const galleryWidget = [...document.querySelectorAll('[data-slider="gallery"]')];
	galleryWidget.forEach((item) => gallery(item));
	
	const stepsWidget = [...document.querySelectorAll('[data-slider="steps"]')];
	stepsWidget.forEach((item) => steps(item));
	
	const stepsShortWidget = [...document.querySelectorAll('[data-slider="steps-short"]')];
	stepsShortWidget.forEach((item) => steps(item, window.matchMedia('(min-width : 1081px)')));
	
	const publicationsWidget = [...document.querySelectorAll('[data-slider="publications"]')];
	publicationsWidget.forEach((item) => publications(item));
	
	const reviewsWidget = [...document.querySelectorAll('[data-slider="reviews"]')];
	reviewsWidget.forEach((item) => reviews(item));
}

(function () {
	init();
}());
